<template>
  <div class="info">
    <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
      @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    LbTable
  },
  props: {
    userId: Number
  },
  data() {
    return {
      name: 'cdd',
      list: [],
      columns: [
        { label: '充值方式', prop: 'typeLabel', minWidth: '120' },
        { label: '支付单号', prop: 'paymentNo', minWidth: '120' },
        { label: '充值金额', prop: 'money', minWidth: '120' },
        { label: '充值时间', prop: 'createdTime', minWidth: '120' },
        { label: '充值状态', prop: 'statusLabel', minWidth: '120' }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  created() {
    this.getUserRelationPageList()
  },
  watch: {
    userId(val) {
      this.userId = val
      this.page.pageNo = 1;
      this.getUserRelationPageList()
    }
  },
  methods: {
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getUserRelationPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getUserRelationPageList()
    },
    getUserRelationPageList() {
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        id: this.userId
      }
      this.axios.post('/user/userInfo/recharge', data)
        .then(res => {
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
.info {
  padding-top: 20px;
  padding-bottom: 20px;

  /deep/ .el-table .el-table__header .el-table__cell {
    padding: 0;
  }

  /deep/ .el-table .el-table__row .el-table__cell {
    color: #303033;
    font-weight: 400;
  }
}
</style>
  
  